var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

export function isLocalizedString(schema) {
    if (schema.type === "object" && schema.properties) {
        var keys = Object.keys(schema.properties);

        if (keys[0]) {
            var test = keys[0].split(':');

            if (test[0] === "locale") {
                return true;
            }
        }
    }

    return false;
}

export function getLocalizedString(schema, props) {
    var languages = props.formContext.languages;


    var properties = {};

    if (languages.length) {

        languages.map(function (language, index) {

            var name = "locale:" + language;

            properties[name] = {
                "type": "string"
            };
        });
    } else {

        properties = {
            "locale:en": {
                "type": "string"
            }
        };
    }

    schema = {
        "type": "object",
        "properties": properties
    };

    return schema;
}

export function getLocalizedStringUi(props) {
    var uiOptions = props.uiOptions,
        formContext = props.formContext;


    var language = void 0;

    if (formContext.language) {
        language = formContext.language;
    }

    var layout = uiOptions.layout,
        field = uiOptions.field;


    if (!layout) {
        layout = "field";
    }

    if (!field) {
        field = "localizedString";
    }

    return _extends({}, uiOptions, {
        language: language,
        layout: layout,
        field: field
    });
}